import { ReactNode } from 'react';
import { Paper, PaperProps } from '@rossum/ui/material';

type ChartWrapperProps = { children: ReactNode } & PaperProps;
export const ChartWrapper = ({ children, ...props }: ChartWrapperProps) => (
  <Paper
    sx={{
      py: 3,
      px: 4,
      height: 1,
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 400,
    }}
    {...props}
  >
    {children}
  </Paper>
);
